import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import { useBoolean } from 'src/hooks/use-boolean';
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { dateformation } from 'src/components/date-format-mdy';
import { useEffect } from 'react';
import { formatCurrency } from '../../risk-register/feching';
// ----------------------------------------------------------------------
export default function UserTableRow({
  row,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  serialNumber,
}) {
  const {
    account_chart,
    bank_information,
    invoice_date,
    notes,
    note,
    debit,
    credit,
    cumulative_credit,
    cumulative_debit,
    balance,
  } = row;
  const confirm = useBoolean();
  const popover = usePopover();
  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{serialNumber}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{account_chart?.code}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{account_chart?.name}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{dateformation(invoice_date)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{account_chart?.account_type?.name}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{bank_information?.bank_name}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>
          {bank_information?.opening_balance
            ? formatCurrency(bank_information?.opening_balance)
            : ''}
        </TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(credit || 0)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(debit || 0)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(cumulative_credit)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatCurrency(cumulative_debit)}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>
          {formatCurrency(parseFloat(balance).toFixed(3) || 0)}
        </TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap' }}>{notes || note}</TableCell>
        <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
          {/*<Tooltip title="Quick Edit" placement="top" arrow>
            <IconButton color={quickEdit.value ? 'inherit' : 'default'} onClick={quickEdit.onTrue}>
              <Iconify icon="solar:pen-bold" />
            </IconButton>
          </Tooltip>*/}

          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            onEditRow(row);
            popover.onClose();
            console.log('>>>>>>>>>', row);
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>
      </CustomPopover>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure want to delete?"
        action={
          <Button variant="contained" color="error" onClick={onDeleteRow}>
            Delete
          </Button>
        }
      />
    </>
  );
}
UserTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
